import { Component,
         AfterViewInit }        from '@angular/core';
import { MatDialog, MatDialogRef }          from '@angular/material';
import { SupplierService }      from './../shared/supplier.service';
import { CompanyService }       from './../shared/company.service';
import { TrainCycleService }       from './../shared/train-cycle.service';
import { Globals }              from './../common/globals';
import { Observable }           from 'rxjs/Observable';
import { TrainDialogModel }     from './train-dialog.model';
import { SortableFilter } from '../common/sortable-filter';
import { PaymentType } from '../common/payment-type.enum';
import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject, pipe } from 'rxjs';
import { TrainPartDialogComponent } from '../train-part-dialog/train-part-dialog.component';
import { SavingDialogComponent } from '../common/saving-dialog.component';
import { TrainService } from '../shared/train.service';
import { groupBy } from 'rxjs/operator/groupBy';
import { SettingService } from '../shared/setting.service';

@Component({
  selector: 'sa-train-dialog',
  template: require('./train-dialog.component.html'),
  styles: [require('./train-dialog.component.scss')]
})
export class TrainDialogComponent implements AfterViewInit {

  public newItem = false;
  public model: TrainDialogModel;
  private companies: Observable<any>;
  private suppliers: Observable<any>;
  private trainCycles: Observable<any>;
  private dataReady = false;
  private currencyIsoCodes = ['CZK'];
  public dataSource = new TrainPartsDataSource([]);

  public PaymentType = PaymentType;

  public errors = [];

  displayedColumns = ['code', 'name', 'companyName', 'active'];

  constructor(
    public dialogRef: MatDialogRef<TrainDialogComponent>,
    private supplierService: SupplierService,
    private companyService: CompanyService,
    private trainCyclesService: TrainCycleService,
    private settingsService: SettingService,
    private trainService: TrainService,
    public dialog: MatDialog,
    public globals: Globals
  ) {

  }

  ngAfterViewInit() {

    let allowedCurrenciesFilter: SortableFilter = { searchString: 'allowedCurrencies' } as SortableFilter;

    Observable.forkJoin(
          this.companyService.getItems(null), 
          this.supplierService.getItems(null), 
          this.trainCyclesService.getItems(null),
          this.settingsService.getItems(allowedCurrenciesFilter)
          ) 
      .subscribe((res: Array<any>) => {
        this.companies = res[0];
        this.suppliers = res[1];
        this.trainCycles = res[2];
        let currencies = res[3];
        if (!(res[1] as Array<any>).filter(c => c.supplierUid === this.model.targetStoreUid).length) {
          this.model.targetStoreUid = '';
        }
        if (!(res[2] as Array<any>).filter(c => c.cycleUID === this.model.cycleUID).length) {
          this.model.cycleUID = '';
        }

        if(!!currencies && currencies.length > 0) {
          this.currencyIsoCodes = currencies[0].value.split(',');
        }

        this.dataSource = new TrainPartsDataSource(this.model.tnTrainParts);
        this.dataReady = true;
      });

      this.model.currenciesPaymentCard = this.model.tnTrainCurrencies.filter(c => c.paymentType === PaymentType.PaymentCard).map(c => c.currencyISOCode);
      this.model.currenciesCash = this.model.tnTrainCurrencies.filter(c => c.paymentType === PaymentType.Cash).map(c => c.currencyISOCode);
  }

  delete() {
    if (confirm('Opravdu si přejete odstranit tento záznam?')) {
      this.dialogRef.close('delete');
    }
  }

  save() {
    this.errors = [];
    // if (!this.model.companyUid || this.model.companyUid.length === 0) {
    //     this.errors.push('Vyberte prosím společnost');
    // }

    this.model.tnTrainParts = this.dataSource.data();

    if (!this.model.trainName || this.model.trainName.length === 0) {
        this.errors.push('Zadejte prosím číslo spoje');
    }
    if (!this.model.targetStoreUid || this.model.targetStoreUid.length === 0) {
        this.errors.push('Zadejte prosím zásobovací sklad');
    }

    var uniqueVals = this.model.tnTrainParts.map(a => a.code.toLowerCase());
    var numsOfVals = uniqueVals.map(uv => this.model.tnTrainParts.filter(a => a.code.toLowerCase() === uv).length);
    if (numsOfVals.filter(n => n > 1).length > 0) {
      this.errors.push('Nelze vícekrát použít stejný kód části spoje');
    }

    this.model.tnTrainCurrencies = [];

    if (this.model.currenciesPaymentCard) {
      this.model.tnTrainCurrencies.push(...this.model.currenciesPaymentCard.map(pc => { return {
        paymentType: PaymentType.PaymentCard,
        trainUID: this.model.trainUid,
        currencyIsoCode: pc
      }}));
    }

    if (this.model.currenciesCash) {
      this.model.tnTrainCurrencies.push(...this.model.currenciesCash.map(pc => { return {
        paymentType: PaymentType.Cash,
        trainUID: this.model.trainUid,
        currencyIsoCode: pc
      }}));
    }

    this.model.targetStoreActive = true;
    if (this.errors.length === 0) {
      this.dialogRef.close('save');
    }
  }

  public addTrainPart() {
    let dialogRef = this.dialog.open(TrainPartDialogComponent, {
      data: { companies: this.companies }
    });
    
    dialogRef.componentInstance.newItem = true;

    dialogRef.afterClosed().subscribe(result => {
      if (result.action === 'save') {
        this.dataSource.add(result.model);
      }
    });
  }

  public editDetail(row, ix) {
    let dialogRef = this.dialog.open(TrainPartDialogComponent, { 
      data: {
        row,
        companies: this.companies,
        canDelete: this.dataSource.data().length > 1
      } 
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.action === 'save') {
        this.model.tnTrainParts[ix] = result.model;
        this.dataSource.update(this.model.tnTrainParts);
      } else if (result.action === 'delete') {
        this.model.tnTrainParts.splice(ix, 1);
        this.dataSource.update(this.model.tnTrainParts);
      }
    });
  }
}

export class TrainPartsDataSource extends DataSource<any> {

  private dataSubject = new BehaviorSubject<any[]>([]);

  data() {
    return this.dataSubject.value;
  }

  update(data) {
    this.dataSubject.next(data);
  }

  add(item) {
    const d = this.dataSubject.value;
    d.push(item);
    this.update(d);
  }

  remove(item) {
    let d = this.dataSubject.value;
    d = d.filter(b => b.code !== item.code);
    this.dataSubject.next(d);
  }

  constructor(data: any[]) {
    super();
    this.dataSubject.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<any[]> {
    return this.dataSubject;
  }

  disconnect() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/train-dialog/train-dialog.component.ts